import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { AdminLoginForm } from "./_components/admin-login-form";

const AdminLoginPage = () => {
  return (
    <div className="h-full flex">
      <div className="flex-[0.5] items-center justify-center bg-gradient-to-r from-[#1d2235] to-[#262a3d] text-white hidden lg:flex">
        <div className="flex flex-col gap-3 items-center">
          <MdOutlineAdminPanelSettings className="w-20 h-20" />
          <h1 className="text-3xl">Login as Admin</h1>
        </div>
      </div>
      <div className="flex-1 bg-[#01020d] text-white flex-col items-center justify-center px-5">
        <div className="flex flex-col h-full items-center justify-center">
          <div className="flex flex-col gap-3 items-center lg:hidden mb-10">
            <MdOutlineAdminPanelSettings className="w-20 h-20" />
            <h1 className="text-3xl">Login as Admin</h1>
          </div>
          <AdminLoginForm />
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
